export const getQueryParam = <T>(value): T | '' => {
  return !Array.isArray(value) ? (value as T) || '' : ''
}

export const getRouteParam = (value): string => {
  return typeof value === 'string' ? value : ''
}
